import { render } from "./reg-tree-list.vue?vue&type=template&id=db8e8532"
import script from "./reg-tree-list.vue?vue&type=script&setup=true&lang=js"
export * from "./reg-tree-list.vue?vue&type=script&setup=true&lang=js"

import "./reg-tree-list.vue?vue&type=style&index=0&id=db8e8532&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/virtual/reg-tree-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "db8e8532"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('db8e8532', __exports__)) {
    api.reload('db8e8532', __exports__)
  }
  
  module.hot.accept("./reg-tree-list.vue?vue&type=template&id=db8e8532", () => {
    api.rerender('db8e8532', render)
  })

}


export default __exports__